import { AutocompleteInput, Create, Edit, NumberInput, ReferenceInput, SelectInput, SimpleForm, TextInput } from "react-admin";


export function ContestWinnerEdit(props) {

    return (
        <Edit {...props}>
            <SimpleForm>
                <ReferenceInput source="contestId" reference="contest">
                    <AutocompleteInput source="name" filterToQuery={searchText => ({ name: searchText })} />
                </ReferenceInput>

                <ReferenceInput source="childId" reference="child">
                    <AutocompleteInput source="name" filterToQuery={searchText => ({ name: searchText })} />
                </ReferenceInput>

                <ReferenceInput source="submissionId" reference="contestSubmission">
                    <AutocompleteInput source="name" filterToQuery={searchText => ({ name: searchText })} />
                </ReferenceInput>

                <NumberInput source="rank" />
            </SimpleForm>
        </Edit>
    )
}